export default __webpack_public_path__ + "static/media/proj1_6.23b4a54c.jpg";